import {
	loadAtlassianSwitcher,
	loadJiraSwitcher,
	loadConfluenceSwitcher,
	loadGenericSwitcher,
} from '../../ui/components/loaders';

export default (product?: string) => {
	loadAtlassianSwitcher();

	if (product === 'jira') {
		return loadJiraSwitcher();
	}

	if (product === 'confluence') {
		return loadConfluenceSwitcher();
	}

	return loadGenericSwitcher();
};
